import { jsx as l } from "react/jsx-runtime";
const o = (c) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64",
    ...c,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        d: "M51.334 49.341c4.29-4.772 6.637-10.876 6.637-17.341 0-6.937-2.701-13.459-7.607-18.365-4.905-4.906-11.427-7.607-18.365-7.607-6.938 0-13.459 2.701-18.365 7.607C8.728 18.541 6.027 25.062 6.027 32c0 6.938 2.701 13.459 7.607 18.365 4.906 4.906 11.427 7.607 18.365 7.607.457 0 1.539-.012 1.993-.036l.006-10.626c5.414-.947 9.541-5.681 9.541-11.361V22.011h-3.661v-6.059l-3.996 1.097v4.962h-7.834v-6.059l-3.996 1.097v4.962h-3.581v13.938c0 5.677 4.122 10.409 9.53 11.359v6.579c-5.116-.458-9.866-2.67-13.542-6.346a21.833 21.833 0 0 1-6.437-15.539 21.83 21.83 0 0 1 6.437-15.539 21.833 21.833 0 0 1 15.539-6.437c5.87 0 11.388 2.285 15.539 6.437a21.833 21.833 0 0 1 6.437 15.539c0 5.87-2.285 11.388-6.437 15.539l3.796 1.802.001-.002ZM24.468 35.947v-9.943h15.076v9.943c0 4.156-3.381 7.539-7.539 7.539-4.158 0-7.539-3.381-7.539-7.539h.002Z"
      }
    )
  }
);
export {
  o as Plug
};
